import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();

// --- REGISTRAZIONE SERVICE WORKER PWA ---
// Registriamo esplicitamente OneSignalSDKWorker.js, che è il SW unificato:
// gestisce sia la cache PWA che le notifiche push (via OneSignal SDK importato al suo interno).
// OneSignal lo registrerà di nuovo al suo init(), ma il browser deduplica correttamente
// registrazioni dello stesso file allo stesso scope.
if ('serviceWorker' in navigator) {
  // Flag IN MEMORIA (non sessionStorage): viene attivato SOLO quando rileviamo
  // un vero aggiornamento del SW (file cambiato sul server).
  // Senza questo check, il `controllerchange` del normale avvio PWA su mobile
  // causa un loop infinito di reload perché clients.claim() lo scatena ad ogni apertura.
  let swUpdatePending = false;

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    // Esce subito se non c'è un aggiornamento effettivo rilevato in questa sessione.
    if (!swUpdatePending) {
      console.log('[SW] controllerchange ignorato — nessun aggiornamento pendente.');
      return;
    }
    
    // Protezione anti-loop tramite timestamp
    // sessionStorage persiste durante il reload nella stessa tab ricaricata
    const lastRefreshTime = sessionStorage.getItem('swRefreshTime');
    const now = Date.now();
    
    if (lastRefreshTime && (now - parseInt(lastRefreshTime, 10) < 10000)) {
        console.log('[SW] Reload bloccato: loop infinito rilevato (ritardo < 10s).');
        return;
    }

    console.log('[SW] Nuova versione attiva — ricarico la pagina.');
    sessionStorage.setItem('swRefreshTime', now.toString());
    window.location.reload();
  });

  window.addEventListener('load', () => {
    // NOTA: Non rimuoviamo il timestamp al load, ci penserà la scadenza dei 10 secondi
    // a sbloccare futuri reload validi.

    navigator.serviceWorker.register('/OneSignalSDKWorker.js')
      .then(registration => {

        // Imposta il flag E manda il messaggio skipWaiting al SW in attesa.
        // Viene chiamato SOLO quando c'è un aggiornamento reale da applicare.
        const forceSkipWaiting = (sw) => {
          swUpdatePending = true;
          sw.postMessage({ type: 'SKIP_WAITING' });
        };

        // Caso 1: aggiornamento già scaricato e in attesa al momento dell'apertura
        if (registration.waiting) {
          console.log('[SW] Aggiornamento in attesa trovato — forzo skipWaiting.');
          forceSkipWaiting(registration.waiting);
        }

        // Caso 2: nuovo SW scaricato durante questa sessione
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (!newWorker) return;

          newWorker.addEventListener('statechange', () => {
            // `installed` + controller esistente = vera nuova versione pronta
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              console.log('[SW] Nuova versione installata — forzo skipWaiting.');
              forceSkipWaiting(newWorker);
            }
          });
        });

      })
      .catch(err => {
        console.warn('[SW] Registrazione fallita:', err);
      });
  });
}
